import { SVGProps } from "react";

export default function MediaIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#667084", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M18.3346 12.5V7.49999C18.3346 3.33332 16.668 1.66666 12.5013 1.66666H7.5013C3.33464 1.66666 1.66797 3.33332 1.66797 7.49999V12.5C1.66797 16.6667 3.33464 18.3333 7.5013 18.3333H12.5013C16.668 18.3333 18.3346 16.6667 18.3346 12.5Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.10156 5.92499H17.9016"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.10156 1.75833V5.80833"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8984 1.75833V5.43333"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.125 12.0417V11.0417C8.125 9.75833 9.03333 9.23333 10.1417 9.87499L11.0083 10.375L11.875 10.875C12.9833 11.5167 12.9833 12.5667 11.875 13.2083L11.0083 13.7083L10.1417 14.2083C9.03333 14.85 8.125 14.325 8.125 13.0417V12.0417V12.0417Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
